import { ArrowUpRight, Gift } from "lucide-react";
import Header from "@/components/sections/Header";
import StickyNav from "@/components/sections/StickyNav";
import Gallery from "@/components/sections/Gallery";
import TeeBooking from "@/components/sections/TeeBooking";
import ProShop from "@/components/sections/ProShop";
import Events from "@/components/sections/Events";
import Hospitality from "@/components/sections/Hospitality";
import OnCourseTech from "@/components/sections/OnCourseTech";
import Partners from "@/components/sections/Partners";
import Membership from "@/components/sections/Membership";
import Footer from "@/components/sections/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-white text-[#1A1A1A]">
      <StickyNav />
      <Header />

{/* COURSE ETIQUETTE & GOLDEN RULES */}
<section className="bg-[#F8F6F0] py-16 border-b border-[#CBA153]/20">
  <div className="max-w-7xl mx-auto px-6 md:px-12">
    
    <div className="text-center mb-12">
      <span className="text-xs font-semibold uppercase tracking-widest text-[#CBA153]">
        Respect the Course
      </span>

      <h2 className="font-serif-luxury text-3xl md:text-4xl mt-2 text-[#0F4C3A]">
        Course Etiquette & Golden Rules
      </h2>

      <p className="mt-4 text-stone-600 max-w-3xl mx-auto leading-relaxed">
        Help us maintain the quality of the course and ensure an enjoyable experience for all players.
      </p>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-12 text-stone-700">
      
      <div className="space-y-5">
        <div className="flex gap-3">
          <span className="text-[#CBA153] font-bold">✓</span>
          <p>Each player must have their own equipment.</p>
        </div>

        <div className="flex gap-3">
          <span className="text-[#CBA153] font-bold">✓</span>
          <p>Dress appropriately with collared shirts, tailored shorts or trousers and golf shoes.</p>
        </div>

        <div className="flex gap-3">
          <span className="text-[#CBA153] font-bold">✓</span>
          <p>Rake bunkers after playing your shot.</p>
        </div>

        <div className="flex gap-3">
          <span className="text-[#CBA153] font-bold">✓</span>
          <p>If players behind are waiting, please allow them to play through.</p>
        </div>

        <div className="flex gap-3">
          <span className="text-[#CBA153] font-bold">✓</span>
          <p>Arrive in good time for your tee booking.</p>
        </div>
      </div>

      <div className="space-y-5">
        <div className="flex gap-3">
          <span className="text-[#CBA153] font-bold">✓</span>
          <p>Keep noise to a minimum and respect fellow golfers.</p>
        </div>

        <div className="flex gap-3">
          <span className="text-[#CBA153] font-bold">✓</span>
          <p>No wheeled vehicles on tees, greens or green approaches.</p>
        </div>

        <div className="flex gap-3">
          <span className="text-[#CBA153] font-bold">✓</span>
          <p>Mobile phones should be kept on silent whilst on the course.</p>
        </div>

        <div className="flex gap-3">
          <span className="text-[#CBA153] font-bold">✓</span>
          <p>Replace divots and help preserve course conditions.</p>
        </div>

        <div className="flex gap-3">
          <span className="text-[#CBA153] font-bold">✓</span>
          <p>Deliberate damage to greens or course property may result in suspension of playing privileges.</p>
        </div>
      </div>

    </div>
  </div>
</section>
      
      {/* LOYALTY CARD TOP BANNER */}
      <section className="bg-[#0F4C3A] text-white border-b border-[#CBA153]/20 py-12">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          
          {/* Left Text Block */}
          <div className="lg:col-span-7">
            <span className="text-xs font-semibold uppercase tracking-widest text-[#CBA153]">
              Exclusive Player Perks
            </span>
            <h2 className="font-serif-luxury text-3xl md:text-4xl mt-2 tracking-tight">
              Join the Gower <span className="italic text-[#CBA153]">Rewards Club</span>
            </h2>
            <p className="text-stone-300 text-sm md:text-base mt-3 max-w-xl leading-relaxed">
              Ditch paper cards. Download your digital pass straight to your Apple Wallet or Google Wallet. 
              Collect a stamp at the Pro Shop desk each visit—<strong className="text-white">buy 5 rounds, get your 6th free.</strong>
            </p>
            <p className="text-xs text-[#CBA153] mt-2 font-medium tracking-wide">
              *Applicable only when booking directly with the club, via our website, or through our official app.
              </p>
            
            <div className="mt-6">
              <a
                href="https://my.favecard.co/the-gower-golf-club"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-[#CBA153] text-[#0F4C3A] hover:bg-[#b88f44] px-6 py-3 font-medium tracking-wide text-sm transition-colors duration-300 group"
              >
                <Gift size={16} />
                Get Your Digital Card
                <ArrowUpRight size={14} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            </div>
          </div>

          {/* Right QR Code Block */}
          <div className="lg:col-span-5 flex items-center lg:justify-end gap-5 border-t lg:border-t-0 lg:border-l border-white/10 pt-8 lg:pt-0 lg:pl-12">
            <div className="bg-white p-2 shrink-0 shadow-lg border border-[#CBA153]/30">
              <img 
                src="/gower-golf-qr.png" 
                alt="The Gower Golf Club Loyalty QR Code" 
                className="w-24 h-24 block object-contain"
              />
            </div>
            <div>
              <p className="text-xs font-semibold uppercase tracking-wider text-[#CBA153]">
                Browsing on a PC?
              </p>
              <p className="text-xs text-stone-300 mt-1 max-w-[200px] leading-normal">
                Scan this QR code with your mobile camera to add the card to your phone instantly.
              </p>
            </div>
          </div>

        </div>
      </section>

      <Gallery />
      <TeeBooking />
      <ProShop />
      <Events />
      <Hospitality />
      <OnCourseTech />
      <Partners />
      <Membership />
      <Footer />
    </main>
  );
}

